import type {Auth0ContextInterface} from "@auth0/auth0-react";
import type {NavigationIntent} from "../AuthContext";
import {B} from "../../build";

export function onAuth0Logout(
    auth0Context: Auth0ContextInterface,
    redirectCallback: NavigationIntent,
) {
    const returnTo = `${window.location.origin}`;
    auth0Context.logout({
        logoutParams: {
            returnTo,
            ...(B.AUTH0_ORGANIZATION ? {organization: B.AUTH0_ORGANIZATION} : {}),
        },
    }).catch(err => {
        console.error('onAuth0Logout: logout failed', err);
        redirectCallback.navigate(redirectCallback.route);
    });
}
